import { Injectable } from '@angular/core';

export interface SessionLogEntry {
  timestamp: string;
  level: 'INFO' | 'WARNING' | 'ERROR' | 'DEBUG';
  process: string;
  file: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class SessionLoggerService {
  private logs: SessionLogEntry[] = [];
  private sessionStartTime: Date;

  constructor() {
    // Track when this session started
    this.sessionStartTime = new Date();
  }

  log(level: 'INFO' | 'WARNING' | 'ERROR' | 'DEBUG', process: string, message: string, file: string = ''): void {
    // Format timestamp to match backend format: YYYY-MM-DD HH:mm:ss
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    
    this.logs.push({
      timestamp,
      level,
      process,
      file,
      message
    });
  }

  info(process: string, message: string, file: string = ''): void {
    this.log('INFO', process, message, file);
  }

  warning(process: string, message: string, file: string = ''): void {
    this.log('WARNING', process, message, file);
  }

  error(process: string, message: string, file: string = ''): void {
    this.log('ERROR', process, message, file);
  }

  debug(process: string, message: string, file: string = ''): void {
    this.log('DEBUG', process, message, file);
  }

  getLogs(): SessionLogEntry[] {
    return [...this.logs];
  }

  getSessionStartTime(): Date {
    return this.sessionStartTime;
  }

  clear(): void {
    this.logs = [];
  }
}
